import { render, staticRenderFns } from "./CardStartStageAction.vue?vue&type=template&id=19a95554"
import script from "./CardStartStageAction.vue?vue&type=script&lang=js"
export * from "./CardStartStageAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports